module.exports = __webpack_public_path__ + "img/inter-v11-latin-800.98fc514.svg";